import { c as _c } from "react/compiler-runtime";
import { Grid, LayoutContainer } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { ContentfulClick } from '@libs/analytics';
import { cutText } from '@libs/contentful/utils';
import HeroCard from './HeroCard/HeroCard';
import type { HeroCardTile4upProps } from './types';
import './HeroCard/HeroCard.scss';
export default function HeroCardTile4up(t0) {
  const $ = _c(16);
  const {
    leftBlock,
    rightBlock,
    rightBlockTextColor
  } = t0;
  if (leftBlock.length !== 1 || rightBlock.length !== 4) {
    return null;
  }
  let t1;
  if ($[0] !== leftBlock) {
    t1 = leftBlock.map(_temp);
    $[0] = leftBlock;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Grid.Item>{t1}</Grid.Item>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== leftBlock[0] || $[5] !== rightBlock || $[6] !== rightBlockTextColor) {
    let t4;
    if ($[8] !== leftBlock[0] || $[9] !== rightBlockTextColor) {
      t4 = (card_0, index_0) => <Grid.Item key={card_0.sysId}><ContentfulClick component={HeroCard} {...card_0} textColor={rightBlockTextColor} eventData={{
          position: index_0 + 1,
          linkText: cn(card_0.preheader && cutText(card_0.preheader, 15), card_0.header, card_0.bodyText && cutText(card_0.bodyText, 70)),
          linkUrl: card_0.link?.webUrl ?? "",
          promoTitle: leftBlock[0].header,
          promoVariant: `storytelling card up - Hero Card Tile 4up - ${card_0.variant}`,
          promoDesc: card_0.internalTitle,
          promoType: "storytelling-card-up__hero-tile"
        }} /></Grid.Item>;
      $[8] = leftBlock[0];
      $[9] = rightBlockTextColor;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t3 = rightBlock.map(t4);
    $[4] = leftBlock[0];
    $[5] = rightBlock;
    $[6] = rightBlockTextColor;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[11] !== t3) {
    t4 = <Grid.Item><Grid variant="side-by-side" gridItemWrap="center">{t3}</Grid></Grid.Item>;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t2 || $[14] !== t4) {
    t5 = <LayoutContainer className="storytelling-hero-card-4-up"><Grid variant="2up" data-testid="storytelling-card-hero-4up">{t2}{t4}</Grid></LayoutContainer>;
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}
function _temp(card, index) {
  return <ContentfulClick component={HeroCard} key={card.sysId} {...card} eventData={{
    position: index + 1,
    linkText: cn(card.preheader && cutText(card.preheader, 15), card.header, card.bodyText && cutText(card.bodyText, 70)),
    linkUrl: card.link?.webUrl ?? "",
    promoTitle: card.header,
    promoVariant: `storytelling card up - Hero Card Tile 4up - ${card.variant}`,
    promoDesc: card.internalTitle,
    promoType: "storytelling-card-up__hero"
  }} />;
}